<template>
  <div class="update-notify mb-2" v-if="needUpdate">
    <div class="update-notify-placeholder" ref="placeholder"></div>
    <div class="update-notify-content" ref="content">
      <span>
        <span class="text-medium-x align-bottom">
          <i class="el-icon-warning-outline"></i>
        </span>
        {{ title }}已修改，目前处于草稿状态，样本仍以修改之前的版本收集数据，如需使用当前版本收集数据请
        <el-button type="text" @click="onUpdateRelease">
          <span class="text-small">更新</span>
        </el-button>
      </span>
    </div>
  </div>
</template>

<script>
import { getSurveyById } from '@/api/survey'
import { getSurveyStatusInfoH } from '@/api/layout/survey-layout/top-header'
import GlobalConfig from '@/global/config'
import { releaseSurvey } from '@/api/wenjuan/wjquestion'
import { mapGetters } from 'vuex'

function getSurveyVersionId(surveyId) {
  return getSurveyById(surveyId).then(res => {
    return res.data.data.versionId
  })
}

function checkSurveyUpdate(surveyId) {
  return Promise.all([getSurveyVersionId(surveyId), getSurveyStatusInfoH({ surveyId })]).then(res => {
    const [currentVersion, status] = res
    const releaseVersionId = status.data.data.releaseVersionId
    return currentVersion !== releaseVersionId
  })
}

export default {
  name: 'UpdateNotify',
  data() {
    return {
      needUpdate: false
    }
  },
  computed: {
    ...mapGetters(['title'])
  },
  methods: {
    onUpdateRelease() {
      getSurveyVersionId(GlobalConfig.getSurveyId()).then(versionId => {
        releaseSurvey({
          surveyId: GlobalConfig.getSurveyId(),
          versionId: versionId,
          isSubmit: 0
        }).then(() => {
          this.needUpdate = false
        })
      })
    },
    onUpdateStatus() {
      checkSurveyUpdate(GlobalConfig.getSurveyId()).then(res => {
        this.needUpdate = res
        if (res) {
          this.$nextTick(() => {
            this.updatePlaceholderHeight()
          })
        }
      })
    },
    initBusHandler() {
      this.$surveyBus.$on('showDraft', this.onUpdateStatus)
      this.$surveyBus.$on('onUpdateStatus', this.onUpdateStatus)
      return function() {
        this.$surveyBus.$off('showDraft')
        this.$surveyBus.$off('onUpdateStatus')
      }
    },
    updatePlaceholderHeight() {
      this.$refs.placeholder.style.height = this.$refs.content.clientHeight + 'px'
    }
  },
  created() {
    this.onUpdateStatus()
  }
}
</script>

<style scoped lang="scss">
.update-notify {
  .update-notify-placeholder {
    height: 32px;
  }

  .update-notify-content {
    @apply text-small text-danger bg-shallow-red text-center;
    padding: 8px;
    line-height: 22px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 2000;
  }
}
</style>
